<template>
  <el-dialog title="Finalizar Aluguel" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="700px" v-loading="loading">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">
      
      <el-row :gutter="10" v-if="mesesFinalizacao.length > 0">
        <el-col :span="20">
          <el-form-item label="Modo de Finalização:" style="font-weight: bold;">
            <el-select
              auto-complete="off"
              v-model="finalizacaoSelecionado"
              placeholder="Selecione"
              style="width: 100%;"
            >
              <el-option
                v-for="item in tiposFinalizacao"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="10" style="margin: 10px 0px 10px 0px;" v-if="!contratoProporcional && exibirCampos">
        <el-col :span="24">
          <strong>Selecione abaixo o período em que o contrato será finalizado: </strong>
        </el-col>
      </el-row>
      
      <el-row :gutter="10" style="margin-bottom:20px;" v-if="exibirTabelaDeRecibos && exibirCampos">
        <el-col :span="24">
          <el-table
            :data="mesesFinalizacao"
            empty-text="Nenhum vencimento encontrado"
            size="small"
            height="150"
            style="background-color: #FFFFFF; "
            stripe
            highlight-current-row
            @row-click="selecionarRecibo">
            <el-table-column label="Mês Série" prop="mesSerie" width="100"/>
            <el-table-column label="Início do Período" prop="inicioPeriodo"/>
            <el-table-column label="Fim do Período" prop="fimPeriodo"/>
          </el-table>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-bottom: 10px;" v-if="exibirCampos">
        <el-col :span="12">
          <el-form-item>
            <template slot="label">
              <strong>Data do Fim do Contrato</strong>
            </template>
            <el-date-picker
              v-mask="'##/##/####'"
              v-model="dataFinalizacao"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-bottom: 40px;" v-if="reciboSelecionado && !contratoProporcional && exibirCampos">
        <el-col :span="12">
          A data deve ser entre {{ reciboSelecionado.inicioPeriodo }} a {{ reciboSelecionado.fimPeriodo }}
        </el-col>
      </el-row>
      <strong v-if="exibirCampos">Opções Adicionais:</strong>
      <el-row :gutter="10" v-if="exibirCampos">
        <el-col :span="12">
          <el-form-item label="">
            <el-checkbox-group v-model="disponibilizarImovel">
              <el-checkbox label="Disponibilizar Imóvel" name="disponibilizarImovel"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>

      <!--
      <el-row :gutter="10" v-if="false">
        <el-col :span="12">
          <el-form-item label="">
            <el-checkbox-group v-model="contratoProporcional" v-if="exibirCheckBoxFinalizarContratoProporcinal">
              <el-checkbox label="Manter em aberto recibos/repasses com vencimento após a data de fim do contrato" name="contratoProporcional"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      -->
    </el-form>
    
    <span slot="footer" v-if="exibirCampos">
      <el-button @click="calcularFinalizacaoHandler" v-if="exibirBotaoCalcularFinalizacao" type="primary" size="small" round class="btn-box-shadow">Calcular</el-button>
      <el-button @click="finalizarContrato" v-if="exibirBotaoFinalizar" type="primary" size="small" round class="btn-box-shadow">Finalizar</el-button>
    </span>
    <app-calcular-finalizacao-dialog v-if="reciboFinalizacao" :disponibilizarImovel="disponibilizarImovel" :reciboFinalizacao="reciboFinalizacao" :possuiRestricoes="possuiRestricoes" :dataFinalizacao="dataFinalizacao" @close="fecharCalcularFinalizacaoDialog" :visibility="visibilidadeCalcularFinalizacaoDialog" />
  </el-dialog>
</template>

<script>

import { mapActions, mapState } from "vuex";
import Util from "../../../util/funcoes.js";
import AppCalcularFinalizacaoDialog from './CalcularFinalizacaoDialog.vue';

export default {
  props: {
    visibility: Boolean
  },
  components: {
    AppCalcularFinalizacaoDialog
  },
  data() {
    return {
      reciboSelecionado: undefined,
      mesesFinalizacao: [],

      dataFinalizacao: undefined,
      disponibilizarImovel: false,

      reciboFinalizacao: undefined,
      possuiRestricoes: false,

      visibilidadeCalcularFinalizacaoDialog: false,

      contratoProporcional: false,

      tiposFinalizacao: [
        { value: "PADRAO", label: "(Padrão) Acerto Proporcional"}, 
        { value: "SEM_CALCULO", label: "Sem Acerto Proporcional"}
      ],
      finalizacaoSelecionado: undefined,
    }
  },
  computed: {
    ...mapState("alugueisContratosStore", {
      aluguel(state) { return state.aluguelSelecionado; }
    }),
    util() {
      return Util;
    },
    exibirBotaoCalcularFinalizacao(){
      return this.mesesFinalizacao.length > 0 && this.contratoProporcional == false
    },
    exibirBotaoFinalizar(){
      return this.mesesFinalizacao.length === 0 || this.contratoProporcional == true
    },
    loading() {
      return this.$store.state.loading;
    },
    exibirTabelaDeRecibos() {
      return !this.contratoProporcional && this.mesesFinalizacao.length > 0;
    },
    exibirCampos(){
      return this.finalizacaoSelecionado || this.mesesFinalizacao.length === 0;
    },
  }, 
  watch: {
    finalizacaoSelecionado: function(newValue, oldValue){
      if((newValue !== oldValue) && newValue){
        this.alertConfirmacao();
      }      
    },
  },  
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisContratosStore", [
      "recuperarMesSerieFinalizacao",

      "finalizarContratoConcluido",
      "calcularFinalizacao",
      ]),

    iniciar() {
      const payload = {
        ...this.aluguel,
        alterarVencimento: false
      }

      this.showLoading();
      this.recuperarMesSerieFinalizacao(payload)
      .then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.mesesFinalizacao = resultado.lista
            this.reciboSelecionado = this.mesesFinalizacao.length > 0 ? this.mesesFinalizacao[0] : undefined
            break;
          default:
            this.$message.warning(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },
    selecionarRecibo(row) {
      this.reciboSelecionado = row
      this.dataFinalizacao = row.inicioPeriodo
    },

    finalizarContrato() {
      if(this.dataFinalizacao === undefined || typeof(this.dataFinalizacao) === 'object') {
        this.exibirAlert('Selecione a Data Fim');
        return;
      }

     this.$confirm("Com base no fim do contrato em " + this.dataFinalizacao
          + ", escolha como deseja tratar os recibos com vencimento após esta data: ", "Atenção", {
          confirmButtonText: "Manter Recibos",
          cancelButtonText: "Cancelar Recibos",
          type: "warnidng",
          distinguishCancelAndClose: true
        })
        .then(() => {
          this.aluguel.isCancelarRecibos = false;
          this.finalizarContratoConcluidoHandler();
        })
        .catch((action) => {
          if(action === 'cancel'){
            this.aluguel.isCancelarRecibos = true;
            this.finalizarContratoConcluidoHandler();            
          }else if(action === 'close'){
            return;
          } 
        });
    },

    finalizarContratoConcluidoHandler() {
      let params = {};
      
      params.id = this.aluguel.id;
      params.dataFim = this.dataFinalizacao;
      params.isCancelarRecibos = this.aluguel.isCancelarRecibos;
      params.disponibilizarImovel = this.disponibilizarImovel;
      params.contratoProporcional = this.contratoProporcional;
      
      this.showLoading();
      this.finalizarContratoConcluido(params)
      .then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.concluir();
            this.reset()
            break;
          default:
            this.$message.warning(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
        this.reset();
      });
    },

    calcularFinalizacaoHandler() {
      if(this.dataFinalizacao === undefined || typeof(this.dataFinalizacao) === 'object') {
        this.exibirAlert('Selecione a Data Fim');
        return;
      }

      if(this.util.compararDatas(this.dataFinalizacao,this.reciboSelecionado.inicioPeriodo) === -1 || this.util.compararDatas(this.dataFinalizacao,this.reciboSelecionado.fimPeriodo) === 1){
        this.exibirAlert('A Data de Fim está fora do período selecionado');
        return;
      }

      let params = {};
      
      params.id = this.aluguel.id;
      params.dataFim = this.dataFinalizacao;
      params.mesSerie = this.reciboSelecionado.mesSerie;
      
      this.showLoading();
      this.calcularFinalizacao(params)
      .then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.exibirCalcularFinalizacaoDialog(resultado.item, false)
            break;
          case "FALHA":
            this.$confirm(resultado.mensagem + ". Deseja finalizar mesmo assim?", "Atenção", {
              confirmButtonText: "Sim",
              cancelButtonText: "Não",
              type: "warning"
            }).then(() => {
              this.exibirCalcularFinalizacaoDialog(resultado.item, true)
            }).catch(() => {});
            break;
          default:
            this.$message.warning(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },

    // DIALOG
    exibirCalcularFinalizacaoDialog(reciboFinalizacao, possuiRestricoes){
      this.reciboFinalizacao = reciboFinalizacao
      this.possuiRestricoes = possuiRestricoes
      this.visibilidadeCalcularFinalizacaoDialog = true;
    },
    fecharCalcularFinalizacaoDialog(resultado) {
      this.visibilidadeCalcularFinalizacaoDialog = false;
      if(resultado && resultado === 'SUCESSO'){
        this.concluir();
      }
    },
      
    exibirAlert(mensagem, titulo='Atenção') {
      this.$alert(mensagem, titulo, { confirmButtonText: "Ok"});
    },

    alertConfirmacao(){
      if(this.finalizacaoSelecionado === 'SEM_CALCULO'){
        //atualizado
        this.exibirAlert("O contrato será finalizado sem o cálculo proporcional dos valores. "
        + "Os recibos e repasses com vencimento após a data de finalização podem ser mantidos ou cancelados pelo usuário, ")
        + "diferindo da finalização padrão.";
        this.contratoProporcional = true;
      }else{
        //atualizado
        this.exibirAlert("O contrato será finalizado com o cálculo proporcional dos valores no período selecionado. " 
        + "Os recibos e repasses com vencimentos após a data de finalização serão cancelados.")
        this.contratoProporcional = false;
      }
    },

    reset(){
      this.reciboSelecionado = undefined
      this.mesesFinalizacao = []

      this.dataFinalizacao = undefined
      this.disponibilizarImovel = false

      this.reciboFinalizacao = undefined
      this.possuiRestricoes = false

      this.visibilidadeCalcularFinalizacaoDialog = false

      this.finalizacaoSelecionado = undefined;

      this.contratoProporcional = false;
    },

    fechar() {
      this.reset()
      this.$emit('close');
    },
    
    concluir() {
      this.$emit('finalizar');
    },
  }
}
</script>
